import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

var _dec, _class;

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import * as _ from 'lodash';
import { ContentCardWrap } from 'components';
import { favoriteChannel, unFavoriteChannel } from 'redux/modules/contentLibrary';
import { connect } from 'react-redux';
var ContentLibraryStar = (_dec = connect(function (state) {
  var orgId = state.organization.current.id;
  return {
    favorites: state.contentLibrary[orgId] && state.contentLibrary[orgId].favorites ? state.contentLibrary[orgId].favorites : [],
    organization: state.organization.current,
    categoryContent: state.contentLibraryContent.categoryContent,
    loadingCategoryContent: state.contentLibraryContent.loadingCategoryContent,
    queues: state.queues[orgId]
  };
}, {
  favoriteChannel: favoriteChannel,
  unFavoriteChannel: unFavoriteChannel
}), _dec(_class = /*#__PURE__*/function (_Component) {
  _inherits(ContentLibraryStar, _Component);

  var _super = _createSuper(ContentLibraryStar);

  function ContentLibraryStar() {
    var _this;

    _classCallCheck(this, ContentLibraryStar);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "handleUnfavorite", function () {
      _this.props.unFavoriteChannel(_this.props.category.id, _this.props.organization.id);
    });

    _defineProperty(_assertThisInitialized(_this), "handleFavorite", function () {
      _this.props.favoriteChannel(_this.props.category.id, _this.props.organization.id, _this.props.category, _this.props.queues);
    });

    return _this;
  }

  _createClass(ContentLibraryStar, [{
    key: "render",
    value:
    /** *******************************************************************************************
     RENDER
    ********************************************************************************************/
    function render() {
      var _this2 = this;

      var isFavorite = this.props.favorites && this.props.favorites.length ? this.props.favorites.find(function (f) {
        return f.slug === _this2.props.category.slug;
      }) : false;
      return /*#__PURE__*/React.createElement("i", {
        style: {
          cursor: 'pointer',
          color: 'gold',
          fontSize: 30
        },
        className: isFavorite ? 'icon ion-ios-star' : 'icon ion-ios-star-outline',
        onClick: function onClick() {
          if (isFavorite) {
            _this2.handleUnfavorite();
          } else {
            _this2.handleFavorite();
          }
        }
      });
    }
  }]);

  return ContentLibraryStar;
}(Component)) || _class);
ContentLibraryStar.defaultProps = {};
export default ContentLibraryStar;